<template>
    <v-text-field
        hide-details
        autocomplete="off"
        class="rtls-search rtls-search--white"
        :placeholder="placeholder"
    >
        <template v-slot:append>
            <v-icon small color="primary">custom:search</v-icon>
        </template>
    </v-text-field>
</template>

<script>
import vuexComponentMixin from '@/js/mixins/vuex-component';
import i18n from '@/js/vue-i18n';
import { toSentenceCase } from '@/js/utils/string-utils';

export default {
    mixins: [vuexComponentMixin],
    props: {
        placeholder: {
            type: String,
            // i18n library is needed because `this.$t(..)` cannot be used as a prop default.
            default: toSentenceCase(i18n.t(`placeholders.search`)),
        },
    },
    emits: ['change'],
    methods: {
        change(value) {
            this.$emit('change', value);
        },
    },
};
</script>
